<div class="page-content">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form mb-10">
    <div class="input-group">
      <input [(ngModel)]="email" formControlName="email" type="email" class="form-control" placeholder="Email">
      <span class="input-group-btn">
        <button type="submit" [disabled]="!form.valid" class="btn btn-primary"><i class="fa fa-send"></i> Send invite</button>
      </span>
    </div>
    <input-errors [control]="form.controls.email" [service]="validationService"></input-errors>
  </form>
  <div class="hr-line-dashed"></div>
  <app-invite-table></app-invite-table>
</div>
